export default {
  usuarios: {
    title: 'Usuarios',
    createTitle: 'Creación de usuarios',
    updateTitle: 'Actualización de usuario',
    deleteTitle: 'Eliminar usuario',
    tableDetailTitle1: 'Permisos',
    tableDetailTitle2: 'Roles',
    detailTitle1: 'General',
    detailTitle2: 'Cambio de contraseña',
    permisos: {
      title: 'Permisos',
      createTitle: 'Creación de permiso',
      addTitle: 'Asignación de permisos',
      updateTitle: 'Actualización de permiso',
      deleteTitle: 'Eliminar permiso',
      deleteMessage: '¿Está seguro de eliminar este permiso?',
      deleteMulTitle: 'Eliminar permisos seleccionados',
      deleteMulMessage: '¿Está seguro de eliminar los permisos selecciondos?',
    },
    roles: {
      title: 'Roles',
      titleList: 'Listado de roles',
      createTitle: 'Creación de rol',
      updateTitle: 'Actualización de rol',
      deleteTitle: 'Eliminar rol',
      deleteMessage: '¿Está seguro de eliminar este rol?',
      tableDetailTitle1: 'Permisos',
      permisos: {
        title: 'Permisos',
        createTitle: 'Creación de permiso',
        addTitle: 'Asignación de permisos',
        updateTitle: 'Actualización de permiso',
        deleteTitle: 'Eliminar permiso',
        deleteMessage: '¿Está seguro de eliminar este permiso?',
      },
    },
  },
  modulos: {
    consultas: 'Consultas',
  },
  consultas: {
    usuariosRegistrados: {
      title: 'Usuarios registrados',
      viewTitle: 'Ver usuario',
      editTitle: 'Editar información usuario',
      tab1: 'Información personal',
      tab2: 'Validación identidad',
      tab3: 'Información pago',
      tab4: 'Perfil',
      tab5: 'Descripción física',
      tab6: 'Servicios',
      tab7: 'Ubicaciones',
      tab8: 'Galeria',
      tab9: 'Historico compras',
      tab10: 'Referidos',
      tab11: 'Bonos',
      tab12: 'Notificaciones',
    },
  },
  catalogo: {
    maestros: {
      categoriaProductos: {
        title: 'Categoría productos',
        createTitle: 'Creación categoría productos',
        updateTitle: 'Actualización categoría productos',
        deleteTitle: 'Eliminar categoría productos',
        deleteMessage: '¿Seguro desea eliminar la categoría productos?',
      },
      productos: {
        title: 'Productos',
        createTitle: 'Creación productos',
        updateTitle: 'Actualización productos',
        deleteTitle: 'Eliminar productos',
        deleteMessage: '¿Seguro desea eliminar el producto?',
        detailTitle1: 'Imágenes',
      },
    },
    procesos: {
    },
  },
  miPerfil: {
    maestros: {
      servicios: {
        title: 'Servicios',
        createTitle: 'Creación servicio',
        updateTitle: 'Actualización servicio',
        deleteTitle: 'Eliminar servicio',
        deleteMessage: '¿Seguro desea eliminar el servicio?',
      },
      clasificacionUsuarios: {
        title: 'Clasificación usuarios',
        createTitle: 'Creación clasificación usuarios',
        updateTitle: 'Actualización clasificación usuarios',
        deleteTitle: 'Eliminar clasificación usuarios',
        deleteMessage: '¿Seguro desea eliminar la clasificación de usuario?',
      },
      identidadSexual: {
        title: 'Identidades sexuales',
        createTitle: 'Creación identidad sexual',
        updateTitle: 'Actualización identidad sexual',
        deleteTitle: 'Eliminar identidad sexual',
        deleteMessage: '¿Seguro desea eliminar la identidad sexual?',
      },
      orientacionSexual: {
        title: 'Orientaciones sexuales',
        createTitle: 'Creación orientación sexual',
        updateTitle: 'Actualización orientación sexual',
        deleteTitle: 'Eliminar orientación sexual',
        deleteMessage: '¿Seguro desea eliminar la orientación sexual?',
      },
      tipoOral: {
        title: 'Tipos de oral',
        createTitle: 'Creación tipo de oral',
        updateTitle: 'Actualización tipo de oral',
        deleteTitle: 'Eliminar tipo de oral',
        deleteMessage: '¿Seguro desea eliminar el tipo de oral?',
      },
      tipoFantasiaFetiche: {
        title: 'Tipos de fantasías y fetiches',
        createTitle: 'Creación tipo de fantasía y fetiche',
        updateTitle: 'Actualización tipo de fantasía y fetiche',
        deleteTitle: 'Eliminar tipo de fantasía y fetiche',
        deleteMessage: '¿Seguro desea eliminar el tipo de fantasía y fetiche?',
      },
      tipoMasaje: {
        title: 'Tipos de masajes',
        createTitle: 'Creación tipo de masaje',
        updateTitle: 'Actualización tipo de masaje',
        deleteTitle: 'Eliminar tipo de masaje',
        deleteMessage: '¿Seguro desea eliminar el tipo de masaje?',
      },
      servicioVirtual: {
        title: 'Servicios virtuales',
        createTitle: 'Creación servicio virtual',
        updateTitle: 'Actualización servicio virtual',
        deleteTitle: 'Eliminar servicio virtual',
        deleteMessage: '¿Seguro desea eliminar el servicio virtual?',
      },
      ojos: {
        title: 'Ojos',
        createTitle: 'Creación ojo',
        updateTitle: 'Actualización ojo',
        deleteTitle: 'Eliminar ojo',
        deleteMessage: '¿Seguro desea eliminar el ojo?',
      },
      cabellos: {
        title: 'Cabello',
        createTitle: 'Creación cabello',
        updateTitle: 'Actualización cabello',
        deleteTitle: 'Eliminar cabello',
        deleteMessage: '¿Seguro desea eliminar el cabello?',
      },
      cuerpos: {
        title: 'Cuerpo',
        createTitle: 'Creación cuerpo',
        updateTitle: 'Actualización cuerpo',
        deleteTitle: 'Eliminar cuerpo',
        deleteMessage: '¿Seguro desea eliminar el cuerpo?',
      },
      pieles: {
        title: 'Piel',
        createTitle: 'Creación piel',
        updateTitle: 'Actualización piel',
        deleteTitle: 'Eliminar piel',
        deleteMessage: '¿Seguro desea eliminar la piel?',
      },
      bustos: {
        title: 'Busto',
        createTitle: 'Creación busto',
        updateTitle: 'Actualización busto',
        deleteTitle: 'Eliminar busto',
        deleteMessage: '¿Seguro desea eliminar el busto?',
      },
      colas: {
        title: 'Cola',
        createTitle: 'Creación cola',
        updateTitle: 'Actualización cola',
        deleteTitle: 'Eliminar cola',
        deleteMessage: '¿Seguro desea eliminar la cola?',
      },
      pollas: {
        title: 'Polla',
        createTitle: 'Creación polla',
        updateTitle: 'Actualización polla',
        deleteTitle: 'Eliminar polla',
        deleteMessage: '¿Seguro desea eliminar la polla?',
      },
      idiomas: {
        title: 'Idioma',
        createTitle: 'Creación idioma',
        updateTitle: 'Actualización idioma',
        deleteTitle: 'Eliminar idioma',
        deleteMessage: '¿Seguro desea eliminar el idioma?',
      },
      depilaciones: {
        title: 'Depilación',
        createTitle: 'Creación depilación',
        updateTitle: 'Actualización depilación',
        deleteTitle: 'Eliminar depilación',
        deleteMessage: '¿Seguro desea eliminar la depilación?',
      },
      etnias: {
        title: 'Etnia',
        createTitle: 'Creación etnia',
        updateTitle: 'Actualización etnia',
        deleteTitle: 'Eliminar etnia',
        deleteMessage: '¿Seguro desea eliminar la etnia?',
      },
      criptomonedas: {
        title: 'Criptomoneda',
        createTitle: 'Creación criptomoneda',
        updateTitle: 'Actualización criptomoneda',
        deleteTitle: 'Eliminar criptomoneda',
        deleteMessage: '¿Seguro desea eliminar la criptomoneda?',
      },
      redes: {
        title: 'Red',
        createTitle: 'Creación red',
        updateTitle: 'Actualización red',
        deleteTitle: 'Eliminar red',
        deleteMessage: '¿Seguro desea eliminar la red?',
      },
    },
    procesos: {
    },
  },
  general: {
    maestros: {
      divisionPolitica: {
        paises: {
          title: 'Países',
          createTitle: 'Creación país',
          updateTitle: 'Actualización país',
          deleteTitle: 'Eliminar país',
          deleteMessage: '¿Seguro desea eliminar el país?',
        },
        departamentos: {
          title: 'Departamentos',
          createTitle: 'Creación departamento',
          updateTitle: 'Actualización departamento',
          deleteTitle: 'Eliminar departamento',
          deleteMessage: '¿Seguro desea eliminar el departamento?',
        },
        ciudades: {
          title: 'Ciudades',
          createTitle: 'Creación ciudad',
          updateTitle: 'Actualización ciudad',
          deleteTitle: 'Eliminar ciudad',
          deleteMessage: '¿Seguro desea eliminar la ciudad?',
        },
      },
      tiposUsuario: {
        title: 'Tipos usuario',
        createTitle: 'Creación tipo de usuario',
        updateTitle: 'Actualización tipo de usuario',
        deleteTitle: 'Eliminar tipo de usuario',
        deleteMessage: '¿Seguro desea eliminar el tipo de usuario?',
      },
      parentesco: {
        title: 'Parentesco',
        createTitle: 'Creación parentesco',
        updateTitle: 'Actualización parentesco',
        deleteTitle: 'Eliminar parentesco',
        deleteMessage: '¿Seguro desea eliminar el parentesco?',
      },
      metodosPago: {
        title: 'Métodos de pago',
        createTitle: 'Creación método de pago',
        updateTitle: 'Actualización método de pago',
        deleteTitle: 'Eliminar método de pago',
        deleteMessage: '¿Seguro desea eliminar el método de pago?',
      },
      bancos: {
        title: 'Bancos',
        createTitle: 'Creación banco',
        updateTitle: 'Actualización banco',
        deleteTitle: 'Eliminar banco',
        deleteMessage: '¿Seguro desea eliminar el banco?',
      },
      validacionIdentidad: {
        ppal: 'Hacer imagen principal',
        ppalMessage: '¿Seguro desea hacer la imagen principal?',
        deleteTitle: 'Eliminar imagen',
        deleteMessage: '¿Seguro desea eliminar la imagen?',
      },
      monedas: {
        title: 'Monedas',
        createTitle: 'Creación moneda',
        updateTitle: 'Actualización moneda',
        deleteTitle: 'Eliminar moneda',
        deleteMessage: '¿Seguro desea eliminar la moneda?',
      },
      terminosYCondiciones: {
        title: 'Términos y condiciones',
        createTitle: 'Creación términos y condiciones',
        updateTitle: 'Actualización términos y condiciones',
        deleteTitle: 'Eliminar términos y condiciones',
        deleteMessage: '¿Seguro desea eliminar los términos y condiciones?',
      },
    },
    procesos: {
    },
  },
  bonos: {
    title: 'Liquidación bonos de usuarios',
    updateTitle: 'Liquidación bonos de usuarios',
  },
  misCompras: {
    maestros: {
      tiposSuscripcion: {
        title: 'Tipos suscripción',
        createTitle: 'Creación tipo suscripción',
        updateTitle: 'Actualización tipo suscripción',
        deleteTitle: 'Eliminar tipo suscripción',
        deleteMessage: '¿Seguro desea eliminar el tipo suscripción?',
      },
    },
    procesos: {
    },
  },
  centroAyuda: {
    maestros: {
      ayudasGraficas: {
        title: 'Ayudas gráficas',
        createTitle: 'Creación ayuda gráfica',
        updateTitle: 'Actualización ayuda gráfica',
        deleteTitle: 'Eliminar ayuda gráfica',
        deleteMessage: '¿Seguro desea eliminar la ayuda gráfica?',
      },
    },
    procesos: {
      sugerencias: {
        title: 'Sugerencias',
      },
      agendarDemostracion: {
        title: 'Agendar demostración',
      },
      enviarPreguntas: {
        title: 'Enviar preguntas',
      },
      preguntasFrecuentes: {
        title: 'Preguntas frecuentes',
        createTitle: 'Creación pregunta frecuente',
        updateTitle: 'Actualización pregunta frecuente',
        deleteTitle: 'Eliminar pregunta frecuente',
        deleteMessage: '¿Seguro desea eliminar la pregunta frecuente?',
        detailTitle1: 'Ayudas gráficas',
      },
    },
  },
  estadisticas: {
    consultas: {
      userRegister: {
        title: 'Usuarios registrados',
      },
      suscripciones: {
        title: 'Suscripciones',
      },
    },
  },
};
